module.exports = __webpack_public_path__ + "img/bg1.70ae7a52.png";